
import { Container, ContainerProps, Spacer } from "@chakra-ui/react"
import React from "react"
import Navbar from "../navbar/Navbar"
import Footer from "./Footer"

type LayoutType = {
    children: any,
    props?: ContainerProps
}

export default function Layout({ children, props }: LayoutType) {
    return (
        <Container display={'flex'} minH={'100vh'} alignItems={'start'} flexFlow={'column'} size={'md'} py={'6'} {...props}>
            <Navbar />
            {children}
            <Spacer />
            <Footer />
        </Container>
    )
}